<div class="container personal-data-container pb-4" *ngIf="!showLoader">
    <h2 class="text-center mb-4 pt-3">MIS DATOS</h2>
    <div class="row justify-content-center">
        <div class="col-md-12 col-sm-11 col-10">
            <div class="table-responsive-container position-relative">
                <div class="table-responsive mb-5">
                    <table class="table table-borderless table-hover" *ngIf="personalData">
                        <tbody>
                        <tr >
                            <td scope="row">Nombre</td>
                            <td class="font-weight-bold"> {{ personalData.nombre }}</td>
                            <td scope="row">Código De Cliente</td>
                            <td class="font-weight-bold"> {{ personalData.codClientePsp }}</td>
                        </tr>
                        <tr >
                            <td scope="row">Primer Apellido</td>
                            <td class="font-weight-bold"> {{ personalData.apellido1 }}</td>
                            <td>Email</td>
                            <td class="font-weight-bold">{{ personalData.emailOnline }}</td>
                        </tr>
                        <tr >
                            <td scope="row">Segundo Apellido</td>
                            <td class="font-weight-bold"> {{ personalData.apellido2 }}</td>
                            <td >Fecha De Nacimiento</td>
                            <td class="font-weight-bold">{{ personalData.fechaNacimiento | date: "dd/MM/yyyy" }}</td>
                        </tr>
                        <tr >
                            <td>Tipo De Documento</td>
                            <td class="font-weight-bold">{{ personalData.desTipoDocumento }}</td>
                            <td scope="row">Lugar De Nacimiento</td>
                            <td class="font-weight-bold"> {{ personalData.birthCountryCode}}</td>
                        </tr>
                        <tr >
                            <td>Número Del Documento</td>
                            <td class="font-weight-bold">{{ personalData.numeroDocumento}}</td>
                            <td>Nacionalidad</td>
                            <td class="font-weight-bold">{{ personalData.birthCountryCode }}</td>
                        </tr>
                        <tr >
                            <td>Fecha De Expiración</td>
                            <td class="font-weight-bold">{{ personalData.expiryDocumento | date: "dd/MM/yyyy" }}</td>
                            <td scope="row">Sexo</td>
                            <td *ngIf="personalData.sexo === 'H'" class="font-weight-bold"> Hombre </td>
                            <td *ngIf="personalData.sexo === 'M'" class="font-weight-bold"> Mujer </td>
                        </tr>
                        </tbody>
                    </table>
                    <div *ngIf="errormessage" class="text-center">
                        {{ errormessage }}
                    </div>
                </div>

            </div>
        </div>
    </div>
    <app-form [inputForm]="modifyDataForm" [address]="personalData.direccion"
              [cp]="personalData.codigoPostal" [population]="personalData.poblacion"
              [province]="personalData.provincia"></app-form>
    <app-form [inputForm]="modifyPhoneForm" [phone]="personalData.telefonoOnline"></app-form>
</div>
<app-loader *ngIf="showLoader"></app-loader>


